import { InspectionForm } from '@/models'
import type { TInspectionsState } from '@/types/state-types'

export default <TInspectionsState>{
  inspectionForm: new InspectionForm(),
  isInspectionFormLoading: false,
  oneTimeInspectionTask: null
}
